import React, {useState} from 'react'
import styled from 'styled-components'
import { SubPageBreadCrumbs } from 'Components/BreadCrumbs'
import { Level2Menu } from 'Components/Menus'
import { DataTable, NewSegmentModal } from './components'
import { Button } from 'antd';
import { THEME } from 'Util/constants';
import { ADD_INSERT_USER_TAGS, ADD_USER_SEGMENTS } from 'Util/mutations';
import { useMutation } from '@apollo/client';

const Container = styled.div``

const ButtonWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .custom-button {
        border-radius: 0px; 
        background-color: ${THEME.colors.lightBlue};
        color: white;
    }
`

const auctionMenu = [
    { title: "All Users", link: "/crm/notifications/all-users" },
    { title: "Segments", link: "/crm/notifications/segments" },
    { title: "Tags", link: "/crm/notifications/tags" },
    { title: "Polls", link: "/crm/notifications/polls" }
]

function CRMSegments() {
    const [visible, setVisible] = useState(false)
    const onCancel = () => {setVisible(false)}

    const [add] = useMutation(ADD_USER_SEGMENTS, {
        onCompleted() {
            setVisible(false)
        },
        onError(e) {
        }
    });

    const onSubmit = (values) => {
        add({
            variables: {
              objects: values
            },
        });
    }
    return (
        <>
            <Container>
                <SubPageBreadCrumbs />
                <Level2Menu menu={auctionMenu} />
                <ButtonWrapper>
                    <Button shape="round" className="custom-button" onClick={() => setVisible(!visible)}>New Segment</Button>
                </ButtonWrapper>
                <NewSegmentModal visible={visible} onCancel={onCancel} onSubmit={onSubmit}/>
                <DataTable />
            </Container>
        </>
    )
}

export default CRMSegments
